import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=f0c9ae08&scoped=true&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"
import style0 from "./tabs.vue?vue&type=style&index=0&id=f0c9ae08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c9ae08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0c9ae08')) {
      api.createRecord('f0c9ae08', component.options)
    } else {
      api.reload('f0c9ae08', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=f0c9ae08&scoped=true&", function () {
      api.rerender('f0c9ae08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/tabs/tabs.vue"
export default component.exports